import { AmendmentConstants } from "./AmendmentType";

export const QueueAppStatusConstants = {
	DocumentsSent: "Documents Sent",
	DocumentReview: "Document Check In",
	VerbalDnA: "Verbal DnA",
	FundingReview: "Funding",
	FundingConfirmation: "Funded",
};

export const getDefaultAmendmentType = (appStatus) => {
	switch (appStatus) {
		// Docs - Documents sent
		case QueueAppStatusConstants.DocumentsSent:
			return AmendmentConstants.NewDocs;
		// Docs - Document Review
		case QueueAppStatusConstants.DocumentReview:
			return AmendmentConstants.Amendment;
		// Verbal DnA
		case QueueAppStatusConstants.VerbalDnA:
			return AmendmentConstants.Amendment;
		// Funding - Funding review
		case QueueAppStatusConstants.FundingReview:
			return AmendmentConstants.ClarificationLetter;
		// Funding - Funding confirmation
		case QueueAppStatusConstants.FundingConfirmation:
			return AmendmentConstants.ClarificationLetter;
		default:
			return AmendmentConstants.Amendment;
	}
};

export const shouldRenderAmendments = (appStatus) => {
	const queueStatusValues = Object.values(QueueAppStatusConstants);
	for (let i = 0; i < queueStatusValues.length; i++) {
		if (queueStatusValues[i] === appStatus) {
			return true;
		}
	}

	return false;
};
